import { ReactNode } from 'react';
import { css } from 'styled-components';
import tw, { styled } from 'twin.macro';

import { StyledOverlay } from '../Overlay/Overlay.styles';
import { StyledBody } from './components/Body/Body.styles';
import { StyledFooter } from './components/Footer/Footer.styles';
import { StyledHeader } from './components/Header/Header.styles';
import { Props } from './Modal';

export const ModalMainContentHost = styled.div`
	${tw`contents`}
`;

export const StyledModal = styled.div<Pick<Props, 'size'>>`
	${tw`relative mx-4 my-8 flex w-full flex-col divide-y divide-gray-200 overflow-auto rounded-md bg-white shadow-xl sm:mx-auto`}

	max-height: calc(100vh - 60px);

	${({ size }) => {
		switch (size) {
			case 'small':
				return css`
					width: 300px;
				`;
			default:
			case 'medium':
				return css`
					width: 640px;
				`;
			case 'large':
				return css`
					width: 900px;
				`;
			case 'full-page':
				return css`
					${tw`
						m-0
						size-full
						max-h-full
						divide-y-0
						rounded-none
						bg-gray-50
					`}

					${StyledHeader} {
						${tw`mx-auto my-0 w-full max-w-[1028px]`}
					}

					& > span {
						${tw`flex grow flex-col`}

						${StyledBody} {
							${tw`mx-auto my-0 w-full max-w-[1028px] grow rounded-none border-none px-6 pb-6`}
						}
					}

					${StyledFooter} {
						${tw`border! border-t! border-gray-200! block flex w-full items-center bg-white`};

						& > * {
							${tw`mx-auto my-0 flex w-full max-w-[1028px] justify-end px-6`}
						}
					}
				`;
		}
	}}
`;

export const StyledModalTransition = styled.div<{ children?: ReactNode }>`
	${tw`fixed inset-0 flex items-start justify-center`}

	//TODO move this to z-index helper
	z-index: 555555;

	// Reuse overlay
	${StyledOverlay} {
		${tw`pointer-events-auto z-0`}
		background: rgba(51, 65, 85, 0.5);
	}

	&.modal-enter {
		${StyledOverlay} {
			${tw`opacity-0`}
		}

		${StyledModal} {
			${tw`transform translate-y-1/4 opacity-0`}
		}
	}

	&.modal-enter-active {
		${StyledOverlay} {
			${tw`opacity-100 transition duration-75 ease-in`}
		}

		${StyledModal} {
			${tw`transform translate-y-0 opacity-100 transition duration-150 ease-in`}
		}
	}

	&.modal-exit {
		${StyledOverlay} {
			${tw`opacity-100`}
		}

		${StyledModal} {
			${tw`transform translate-y-0`}
		}
	}

	&.modal-exit-active {
		${StyledOverlay} {
			${tw`opacity-0 transition duration-75 ease-in`}
		}

		${StyledModal} {
			${tw`transform translate-y-1/4 opacity-0 transition duration-150 ease-in`}
		}
	}
`;
